// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

export const driverDeleteMessage = (name: string, blockedBy: string[]) => blockedBy.length
  ? '"' + name + '" is used by ' + blockedBy.join(', ') + '. Remove it from those formulas in Settings first.'
  : 'Delete "' + name + '"? It is removed from the plan, including the values typed for it. The change log keeps a record of who deleted it.';

export default function ConfirmDeleteModal({ title, message, confirmLabel, onConfirm, onClose }: { title: string; message: string; confirmLabel: string; onConfirm: (() => void) | null; onClose: () => void }) {
  const confirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };
  const onKey = e => {
    if (e.key === 'Escape') onClose();
  };

  return (
    <div onClick={onClose} onKeyDown={onKey} style={sx(`position:fixed;inset:0;z-index:60;background:rgba(8,35,76,0.45);display:flex;align-items:center;justify-content:center;padding:24px`)}>
      <div role="alertdialog" aria-label={title} onClick={e => e.stopPropagation()} style={sx(`width:100%;max-width:380px;background:#fff;border-radius:16px;box-shadow:0 30px 60px -25px rgba(8,35,76,0.5);padding:20px`)}>
        <div style={sx(`display:flex;align-items:center;gap:10px;margin-bottom:10px`)}>
          <div style={sx(`flex:1;min-width:0;font-size:15px;font-weight:600;color:var(--ink);letter-spacing:-0.01em`)}>{title}</div>
          <button className="gmHover" onClick={onClose} aria-label="Close" style={sx(`flex:none;width:26px;height:26px;display:flex;align-items:center;justify-content:center;border:1px solid #DCE4F2;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:13px;line-height:1;cursor:pointer`)} data-hover="background:#F5F8FA">×</button>
        </div>
        <p style={sx(`margin:0;font-size:12.5px;line-height:1.5;color:var(--ink-3)`)}>{message}</p>
        <div style={sx(`display:flex;justify-content:flex-end;gap:8px;margin-top:18px`)}>
          <button className="gmHover" autoFocus={!onConfirm} onClick={onClose} style={sx(`height:32px;padding:0 14px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:12.5px;cursor:pointer`)} data-hover="background:#F5F8FA">{onConfirm ? 'Cancel' : 'Close'}</button>
          {onConfirm ? <button autoFocus onClick={confirm} style={sx(`height:32px;padding:0 16px;border:none;border-radius:999px;background:#E5484D;color:#fff;font-family:inherit;font-size:12.5px;font-weight:500;cursor:pointer`)}>{confirmLabel}</button> : null}
        </div>
      </div>
    </div>
  );
}
